"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addExperimenterButtons = addExperimenterButtons;
exports.setupFullscreenButton = setupFullscreenButton;
const components_1 = require("./components");
const taskStore_1 = require("../../../taskStore");
const appTimer_1 = require("./appTimer");
const initPageSetup_1 = require("../../../utils/initPageSetup");
const taskSetup_1 = require("../../taskSetup");
const audioHandler_1 = require("./audioHandler");
let pageSetup = null;
function addExperimenterButtons() {
    // don't add if disabled or if they're already there
    if (document.querySelector('.experimenter-button-container') != null || !(0, taskStore_1.taskStore)().experimenterButtons) {
        return;
    }
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'experimenter-button-container';
    buttonContainer.innerHTML = `
        <button class="utility" id="menu" state="closed">
            ${components_1.menuButtonSvg}
        </button>
        <button class="utility transparent" id="exit" style="display: none;">
            ${components_1.exitButtonSvg}
        </button>
        <button class="utility transparent" id="pause" style="display: none;">
            ${components_1.pauseButtonSvg}
        </button>
    `;
    document.body.appendChild(buttonContainer);
    const pauseButton = document.getElementById('pause');
    pauseButton === null || pauseButton === void 0 ? void 0 : pauseButton.addEventListener('click', () => {
        onPause();
    });
    const exitButton = document.getElementById('exit');
    exitButton === null || exitButton === void 0 ? void 0 : exitButton.addEventListener('click', () => {
        onExit();
    });
    const menuButton = document.getElementById('menu');
    menuButton === null || menuButton === void 0 ? void 0 : menuButton.addEventListener('click', () => {
        onMenuPress(menuButton);
    });
    pageSetup = new initPageSetup_1.InitPageSetup(4000, (0, taskStore_1.taskStore)().translations);
    pageSetup.init();
    const popup = document.createElement('div');
    popup.id = 'exit-confirmation-popup';
    popup.classList.add('exit-confirmation-popup');
    popup.textContent = (0, taskStore_1.taskStore)().translations.generalConfirmExit || 'Are you sure you want to exit the game?';
    popup.style.display = 'none';
    const popupButtonContainer = document.createElement('div');
    popupButtonContainer.id = 'exit-confirmation-popup-buttons';
    popupButtonContainer.classList.add('exit-confirmation-popup-buttons');
    popupButtonContainer.innerHTML = `
        <button class="primary small">${(0, taskStore_1.taskStore)().translations.yes || 'Yes'}</button>
        <button class="primary small">${(0, taskStore_1.taskStore)().translations.no || 'No'}</button>
    `;
    popup.appendChild(popupButtonContainer);
    // equalize button widths
    const popupButtons = popupButtonContainer.querySelectorAll('button');
    const standardWidth = popupButtons[0].getBoundingClientRect().width;
    popupButtons[0].style.width = standardWidth.toString() + 'px';
    popupButtons[1].style.width = standardWidth.toString() + 'px';
    document.body.appendChild(popup);
}
function setupFullscreenButton() {
    const fullscreenButton = document.getElementById('fullscreen');
    fullscreenButton === null || fullscreenButton === void 0 ? void 0 : fullscreenButton.addEventListener('click', () => {
        onFullscreen();
    });
    document.addEventListener('fullscreenchange', () => {
        if (!fullscreenButton) {
            return;
        }
        if (document.fullscreenElement) {
            fullscreenButton.style.visibility = 'hidden';
        }
        else {
            fullscreenButton.style.visibility = 'visible';
        }
    });
}
function onPause() {
    if ((0, taskStore_1.taskStore)().taskTimer != null) {
        clearTimeout((0, taskStore_1.taskStore)().taskTimer);
        (0, taskStore_1.taskStore)('taskTimer', null);
    }
    (0, taskStore_1.taskStore)('taskTimerPauseBeganAt', Date.now());
    pageSetup === null || pageSetup === void 0 ? void 0 : pageSetup.onPause();
    const playButton = document.getElementById('play-button');
    playButton === null || playButton === void 0 ? void 0 : playButton.addEventListener('click', () => {
        onResume();
    });
    audioHandler_1.PageAudioHandler.stopAndDisconnectNode();
    (0, taskStore_1.taskStore)('isPaused', true);
}
function onResume() {
    (0, taskStore_1.taskStore)('isPaused', false);
    (0, appTimer_1.finalizeCurrentPauseSegment)();
    const maxTimeInMilliseconds = Math.max(Number((0, taskStore_1.taskStore)().maxTime), 1) * 60000;
    const remainingMs = Math.max(0, maxTimeInMilliseconds - (0, appTimer_1.getActiveTaskElapsedMs)());
    const timerId = setTimeout(() => {
        (0, taskStore_1.taskStore)('maxTimeReached', true);
        clearTimeout(timerId);
    }, remainingMs);
    (0, taskStore_1.taskStore)('taskTimer', timerId);
    // re-enable all buttons
    const buttons = Array.from(document.querySelectorAll('button'));
    buttons.forEach((button) => {
        button.disabled = false;
    });
    // trigger replay button, which will repeat audio and animations
    audioHandler_1.PageAudioHandler.stopAndDisconnectNode();
    const replayButton = document.getElementById('replay-btn-revisited');
    if (replayButton && !replayButton.disabled) {
        replayButton.click();
        replayButton.disabled = true;
    }
}
function onExit() {
    openPopup();
    const popupButtons = document.getElementById('exit-confirmation-popup-buttons').querySelectorAll('button');
    popupButtons[0].addEventListener('click', () => {
        document.body.innerHTML = '';
        (0, taskStore_1.taskStore)('taskComplete', true);
        taskSetup_1.jsPsych.endExperiment();
    });
    popupButtons[1].addEventListener('click', () => {
        closePopup();
        const menuButton = document.getElementById('menu');
        const exitButton = document.getElementById('exit');
        const pauseButton = document.getElementById('pause');
        exitButton.style.display = 'none';
        pauseButton.style.display = 'none';
        menuButton.classList.remove('open');
        menuButton.setAttribute('state', 'closed');
    });
}
function onFullscreen() {
    if (document.fullscreenElement) {
        return;
    }
    document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error enabling fullscreen: ${err.message}`);
    });
}
function onMenuPress(menuButton) {
    const exitButton = document.getElementById('exit');
    const pauseButton = document.getElementById('pause');
    if (menuButton.getAttribute('state') === 'closed') {
        exitButton.style.display = 'block';
        pauseButton.style.display = 'block';
        menuButton.classList.add('open');
        menuButton.setAttribute('state', 'open');
    }
    else {
        exitButton.style.display = 'none';
        pauseButton.style.display = 'none';
        menuButton.classList.remove('open');
        menuButton.setAttribute('state', 'closed');
    }
}
function openPopup() {
    const popup = document.getElementById('exit-confirmation-popup');
    if (popup) {
        popup.style.display = 'block';
    }
}
function closePopup() {
    const popup = document.getElementById('exit-confirmation-popup');
    if (popup) {
        popup.style.display = 'none';
    }
}
